import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ProductGroupSetDefaultParams {
    readonly externalId: string;
    readonly mode: 'set' | 'unset';
}

export type ProductGroupSetDefaultResponse = {
    value: number,
    version: string
}[];

export class ProductGroupSetDefaultCommand extends Command<ProductGroupSetDefaultParams, ProductGroupSetDefaultResponse> { }

export class ProductGroupSetDefaultCommandHandlerBase implements CommandHandler<ProductGroupSetDefaultCommand, ProductGroupSetDefaultParams, ProductGroupSetDefaultResponse> {
    private static Url = TaggedUrl.join('products/groups/default/:externalId', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: ProductGroupSetDefaultCommand): Promise<ProductGroupSetDefaultResponse> {
        const url = fillPlaceholders(ProductGroupSetDefaultCommandHandlerBase.Url, { externalId: command.params?.externalId });
        const request = command.params?.mode === 'set' ? this.http.put(url) : this.http.delete(url);

        return(await request).data;
    }
}
